"use client";

import { Button, Modal, TextInput } from "flowbite-react";
import { useState, useEffect } from "react";
import { useAuth } from "../Management/AuthContext";
import axios from "axios";

export default function ButtonEdit({ id, name, onSaved }) {
  const [openModal, setOpenModal] = useState(false);
  const { user } = useAuth();
  const [categoryName, setCategoryName] = useState(name);
  const [notification, setNotification] = useState({ message: "", type: "" });

  useEffect(() => {
    if (name) {
      setCategoryName(name);
    }
  }, [name]);

  const showNotification = (message, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => {
      setNotification({ message: "", type: "" });
    }, 3000);
  };

  function onCloseModal() {
    setOpenModal(false);
  }

  const saveCategory = async () => {
    if (categoryName.trim() === "") {
      showNotification("Hãy nhập tên danh mục", "error");
      return;
    }

    axios.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;

    try {
      const response = await axios.post(
        "https://api-bluerise.bluerise.com.vn/category/save",
        {
          id: id,
          name: categoryName,
        }
      );

      if (response.status === 200) {
        onSaved({ id, categoryName });
        showNotification("Lưu thẻ thành công", "success");
        setOpenModal(false);
      } else {
        showNotification("Lưu thẻ không thành công", "error");
      }
    } catch (error) {
      console.error("Có lỗi xảy ra khi lưu danh mục:", error);
      showNotification("Đã có lỗi xảy ra. Vui lòng thử lại.", "error");
    }
  };

  return (
    <>
      {notification.message && (
        <div
          className={`fixed top-4 right-4 z-50 p-4 text-white ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          } rounded shadow`}
        >
          {notification.message}
        </div>
      )}
      <Button
        className={id == 0 ? "" : "bg-green-300"}
        onClick={() => setOpenModal(true)}
      >
        {id == 0 ? "Thêm" : "Sửa"}
      </Button>
      <Modal show={openModal} size="md" onClose={onCloseModal} popup>
        <Modal.Header />
        <Modal.Body>
          <div className="space-y-6">
            <h3 className="text-xl font-medium text-gray-900 dark:text-white text-center">
              {id == 0 ? "Thêm" : "Sửa"} tên thẻ
            </h3>
            <div>
              <TextInput
                placeholder="Nhập tên thẻ"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </div>
            <div className="w-full flex items-center justify-center">
              <Button onClick={saveCategory}>Lưu</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
